import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { RootState } from "../../../../store/store";
import Drivers from "./Drivers/Drivers";
import Vehicles from "./Vehicles/Vehicles";
import { GetPolicyRisks } from "../../../../store/user/policyDetails/policyDetailsActions";

const VehiclesAndDrivers = () => {
  const dispatch = useAppDispatch();
  const { policyId, carrier, system, lobCode } = useParams();

  const { policyVehicles, policyDrivers } = useAppSelector(
    (store: RootState) => store.policyDetails
  );

  useEffect(() => {
    if (policyId && carrier && system && lobCode) {
      dispatch(GetPolicyRisks({ policyId, carrier, system, lobCode }));
    }
  }, [policyId, carrier, system, lobCode, dispatch]);

  return (
    <Box 
      sx={{ padding: "20px 0px" }}
      id="vehicles_drivers_container"
      data-test-id="vehicles_drivers_container"
      aria-label="Vehicles and drivers section"
    >
      <Vehicles vehicles={policyVehicles} />
      <Drivers
        drivers={policyDrivers}
        addDriver={true}
        displayMoreOptions={true}
      />
    </Box>
  );
};

export default VehiclesAndDrivers;
